import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import {Alert, Button, Card, Steps, Table, Tag,} from 'antd';
import {ColumnsType, TableProps} from "antd/es/table";
import {Dayjs} from 'dayjs';
import LoginInscripcions from "./LoginInscripcions";
import NavBar from "../components/NavBar";
import Colors from "../../styles/Colors";
import {BiArrowBack, BiArrowToLeft, BiArrowToRight, BiCheck, BiPencil, BiPlus, BiRefresh} from "react-icons/bi";
import Contacte from "../../model/inscripcions/Contacte";
import InscripcioContacte from "./components/InscripcioContacte";
import {GetInscripcionsId} from "../../dao/inscripcions/GetInscripcionsId";
import Autoritzats from "./components/Autoritzats";
import PagadorModal from "./components/PagadorModal";
import Inscripcio from "./components/Inscripcio";
import Autoritzacions from "./components/Autoritzacions";
import {PostInscripcionsContacteSwitch} from "../../dao/inscripcions/PostInscripcionsContacteSwitch";
import Infants from "./components/Infants";
import {GetInscripcionsNova} from "../../dao/inscripcions/GetInscripcionsNova";
import NavBarInscripcions from "../components/NavBarInscripcions";

const InscripcioGestioId = () => {
    const titol: string = "INSCRIPCIONS";
    const nomPermis: string = "INSCRIPCIONS";

    const {isLoggedIn, userId, user, page, userDni, userCognom} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id_inscripcio} = useParams();

    const [current, setCurrent] = useState(0);

    const [coleccio, setDades] = useState<Contacte[]>([]);
    const [elementSelected, setElementSelected] = useState<Contacte>(new Contacte());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [showSeguent, setShowSeguent] = useState(false);
    const [visible, setVisible] = useState(false);
    const [finalitzada, setFinalitzada] = useState(false);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);

    const steps = [
        {
            title: 'Pagadors',
            description: 'Persona(es) de contacte.',
        },
        {
            title: 'Infants',
            description: 'Infant(s) inscrits.',
        },
        {
            title: 'Inscripció',
            description: 'Dades de la inscripció.',
        },
        {
            title: 'Autoritzats',
            description: 'Persones Autoritzades.',
        },
        {
            title: 'Autoritzacions',
            description: 'Acceptació de condicions.',
        },
    ];

    function checkPagador(coleccio: Contacte[]) {
        const sumaQuotas = coleccio
            .filter(contacte => contacte.estat === 1)
            .reduce((suma, contacte) => suma + contacte.quota, 0);
        const contactosConEmail = coleccio
            .filter(contacte => contacte.email !== null);

        const hayEmailIntroducido = contactosConEmail.length > 0;
        if (sumaQuotas === 100) {
            if (hayEmailIntroducido)
                setShowSeguent(true);
        }
        else
            setShowSeguent(false);
    }


    useEffect(() => {
        const isDocumentacioPath = window.location.pathname.endsWith('/documentacio');
        setFinalitzada(isDocumentacioPath);
        if (isDocumentacioPath) setCurrent(2);
        if (userDni !== '' && userCognom !== '') {
            handleLoadingChange(true)
            checkDades();
        }
    }, [userDni, userCognom]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetInscripcionsId(id_inscripcio + "", page);
        setDades(dades);
        checkPagador(dades);
        await handleLoadingChange(false);
    }

    function next() {
        if (current !== 2) setShowSeguent(false);
        setCurrent(current + 1 > steps.length ? steps.length : current + 1);
    }

    function back() {
        setCurrent(current - 1 < 0 ? 0 : current - 1);
    }

    function changePagadors(valor: boolean) {
        setShowSeguent(valor);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: number) {
        //await DeleteIngredient(id, page);
        await checkDades();
    }

    function afegirElement(element: Contacte) {
        setShowSeguent(false);
        setNouElement(!nouElement);
        setVisible(true);
        setElementSelected(element);
    }

    function togleNouElement(element: Contacte) {
        setShowSeguent(false);
        setNouElement(!nouElement);
        setVisible(true);
        setElementSelected(element);
    }

    function handleCloseModal() {
        setNouElement(false);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Contacte[]) {
        const ingredientNames = elements.map((element) => ({
            text: element.cognoms,
            value: element.cognoms,
        }));
        setNomFiltres(ingredientNames);
    }


    const tableProps: TableProps<Contacte> = {
        loading
    };

    const onChange: TableProps<Contacte>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            //console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender = (ele: Contacte) => {
        return (
            <InscripcioContacte element={ele}/>
        );
    };

    async function handleDownload(id: string) {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    async function changeActiu(ele: Contacte) {
        handleLoadingChange(true)
        setShowSeguent(false);
        await PostInscripcionsContacteSwitch(id_inscripcio + "", page, ele);
        onClose(false);
    }

    const columns: ColumnsType<Contacte> = [
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            render: (estat, ele) => (
                <>{ele.nom}{" "}{ele.cognoms}</>
            ),
        },
        {
            key: 'dni',
            title: 'DNI',
            dataIndex: 'dni',
            width: 30,
        },
        {
            key: 'quota',
            title: 'Quota',
            dataIndex: 'quota',
            width: 30,
            render: (estat, ele) => (
                <>
                    <Tag color={showSeguent ? "success" : "warning"}>{ele.quota}{"%"}</Tag>
                </>
            ),
        },
        {
            key: 'estat',
            title: 'Estat',
            dataIndex: 'estat',
            width: 30,
            render: (estat, ele) => (
                <>
                    <Tag color={ele.estat === 1 ? "success" : "warning"}>{ele.estat === 1 ? "ACTIU" : "NO ACTIU"}</Tag>
                </>
            ),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 50,
            render: (estat, ele) => (
                <>
                    <Button title={"Activar / Desactivar"} style={{backgroundColor: Colors.colors.color5}}
                            onClick={() => changeActiu(ele)}>{ele.estat === 1 ? "DESACTIVAR" : "ACTIVAR"}</Button>
                    {" "}
                    <Button title={"Modificar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElement(ele)}><BiPencil/></Button>
                </>
            ),
        },
    ];

    function goBack() {
        window.history.back();
    }

    function onClose(value: boolean) {
        checkDades();
        setVisible(false);
    }

    if (isLoggedIn) {
        return (
            <div>
                <NavBarInscripcions/>
                <br/>
                <div className={"general"} style={{display: "flex", flexDirection: "row"}}>
                    <div style={{flex: "1"}}>
                        <Steps

                            progressDot
                            current={current}
                            status="error"
                            direction="vertical"
                            items={steps}
                        />
                    </div>
                    <div style={{flex: "4"}}>
                        {current === 0 && (
                            <>
                                <div className={"actionButtons"}>
                                    <Button title={"Sortir"} style={{backgroundColor: Colors.colors.color4}}
                                            onClick={() =>
                                                goBack()}><BiArrowBack/> SORTIR</Button>{" "}
                                    <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color5}}
                                            onClick={() =>
                                                checkDades()}><BiRefresh/> REFRESCAR</Button>{" "}
                                    <Button title={"Nou"} style={{backgroundColor: Colors.colors.color6}}
                                            onClick={() =>
                                                afegirElement(new Contacte())}><BiPlus/> AFEGIR PAGADOR</Button>
                                </div>
                                <h4 className={"titol"}>{"PAGADORS"}</h4>
                                <Card bordered={true} className={"elemento"}>
                                    <Table
                                        {...tableProps}
                                        scroll={{y: 240}}
                                        onChange={onChange}
                                        columns={columns}
                                        expandable={{
                                            expandedRowRender: (record) =>
                                                expandedRowRender(record),
                                            rowExpandable: (record) => true,

                                        }}
                                        dataSource={coleccio}
                                    />

                                    {current < steps.length - 1 && !showSeguent && (
                                        <>
                                            <Alert message={"Afegeix mínim un pagador i la suma de tots ha de fer el 100%"}
                                                   type={"warning"}/>
                                            <Alert message={"Cal modificar les dades del pagador!"}
                                                   type={"info"}/>
                                        </>
                                    )}
                                </Card>
                            </>
                        )}

                        {current === 1 && <Infants id_inscripcio={id_inscripcio + ""} page={page} goBack={goBack} checkInfants={setShowSeguent}/>}
                        {current === 2 && <Inscripcio id_inscripcio={id_inscripcio + ""} page={page} goBack={goBack} checkInscripcions={setShowSeguent}/>}
                        {current === 3 && <Autoritzats id_inscripcio={id_inscripcio + ""} page={page} goBack={goBack}/>}
                        {current === 4 &&
                            <Autoritzacions id_inscripcio={id_inscripcio + ""} page={page} goBack={goBack}/>}

                        <div className={"actionButtons"}>
                            {current != 0  && !finalitzada && (
                                <Button title={"Anterior"} style={{backgroundColor: Colors.colors.color4}}
                                        onClick={() =>
                                            back()}> <BiArrowToLeft/> ANTERIOR</Button>
                            )} {" "}
                            {current < steps.length - 1 && showSeguent && !finalitzada && (
                                <Button title={"Següent"} style={{backgroundColor: Colors.colors.color5}}
                                        onClick={() =>
                                            next()}>SEGÜENT <BiArrowToRight/> </Button>
                            )}
                        </div>
                    </div>
                </div>
                {visible && <PagadorModal element={elementSelected} visible={visible} onClose={onClose}/>}
            </div>
        );
    } else {
        return (
            <LoginInscripcions/>
        );
    }
};
export default InscripcioGestioId;
